import $ from 'jquery';
import { closeModal } from '@/function/function.js';
import { openMenu, closeMenu, open_menu_state, convertDateToDdMmYyyy } from '@/function/function.js';
import EnteteBonEtFacture from '@/components/en-tete-bon-facture';

import { cca_config } from '@/config';

export default {
    name: 'factures',
    components: {
        EnteteBonEtFacture
    },
    props: ["passedConsult"],
    data() {
        return {
            user_role: 0,
            compte_id: 0,
            user_id: 0,
            date_facture: '',
            filename: '',
            
            today_date: this.date_function(),
            ref_bon: '',
            display_all_loading: true,
            save_loading: false,
            loadingAnalyse: false,
            loadingExamen: false,
            is_savable: true,
            is_printable: false,
            idUser: 1,
            vm_state: open_menu_state,
            operation_saved: null,
            all_soins: null,
            
            box1: 0,
            box2: 1,
            box3: 1,
            operation_selected: null,
            somme_encaisse: 0,
            analyse_to_pay_id: 0,
            analyse_to_pay_montant: 0,
            qte_medoc: [],
            index_medicament_selected: null,
            carnets: [],
            // Determine s'il y a eu un paiement déjà effectué
            is_paid_before: false, //  Mettre à false par defaut

            consult_back: null,
            consultation_reste: 0,
            consultation_paye: 0,
            analyses_reste: 0,
            analyses_paye: 0,
            prescriptions_reste: 0,
            cat_reste: 0,
            
            analyse_paid_status: [],
            etat_analyse: false,

            soins_differes: [],

            total_prix_examen: 0,
            total_reste_examen: 0,

            total_assureur: {
                consultation: 0,
                analyse: 0,
                examen_para: 0,
                protocoles: 0,
                ordonnance: 0,
            },

            total_assure: {
                consultation: 0,
                analyse: 0,
                examen_para: 0,
                protocoles: 0,
                ordonnance: 0,
            },

            // Info Demande analyse
            prix_anal: [],
            prix_anal_loading: true,
            b_total_analyse: 0,
            p_alys_assure: [],

            // Info Demande examen
            prix_exm: [],
            b_total_examen: 0,
            p_exm_assure: [],

            // Info consultation
            prix_consult: [],

            // Info Protocoles soins
            p_soins_restant: 0,
            prix_inj: [],
            prix_injectables: 0,

            b_total_admission: 0,
            b_total_acte: 0,
            b_total_conso: 0,
            b_total_inj: 0,
            p_assure: [],
            p_tot_assure: [],

            // Info Ordonnance
            prix_ord: [],
            b_total_ordonnance: 0,
            p_ord_assure: [],

            soins: [],

            filter_bill: [
                {
                    id: 1,
                    libelle: 'Filtrer'
                },
                {
                    id: 2,
                    libelle: 'Différée'
                },
                {
                    id: 3,
                    libelle: 'En attente'
                }
            ],
            chosen_filter: {
                id: 1,
                libelle: 'Filtrer'
            }
        }
    },

    watch: {
        chosen_filter() {
            if (this.chosen_filter.id == 2) {
                this.$router.push({ path: '/consultations-all/factures-differees/'+this.passedConsult });
            } else if (this.chosen_filter.id == 3) {
                this.$router.push({ path: '/consultations-all/factures-en-attentes/'+this.passedConsult });
            }
        }
    },
    
    computed: {
        /**
         * User Info
         * @returns 
         */
        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        activeRole() {
            return this.$store.getters['activeRole'];
        },

        patient() {
            return (this.consultation) ? this.consultation.patient : null
        },

        patient_est_assure() {
            return this.$store.getters['patient_est_assure'];
        },

        info_assurance() {
            return this.$store.getters['info_assurance'];
        },

        consultation() {
            return this.consult_back
        },

        analyses() {
            return this.$store.getters["analyses_for_consult"]
        },

        bulletin_id() {
            return this.$store.getters["analyses_for_consult"].id
        },

        prescription() {
            return this.$store.getters["prescriptions_pharmacie"]
        },

        prix_carnet() {
            let total = 0;
            this.carnets.forEach((el) => {
                if (el.libelle == 'Apport social') {
                    total -= parseInt(el.montant)
                } else {
                    total += parseInt(el.montant)
                }
                
            });

            return total;
        },

        prescriptions_paye() {
            let total = 0;
            if (this.prescription) {
                this.prescription.forEach((data, index) => {
                    // calculer le prix
                    let prix = 0
                    prix = parseInt(this.qte_medoc[index]) * parseInt(data.prix)
                    if (prix > 0)
                        total += prix;
                })
            }
            return parseInt(total);
        },

        // Total Admission
        total_admission() {
            let total = 0

            this.soins.admissions.forEach(data => {
                total += data.total
            })

            return total
        },

        total_soins() {
            if (this.soins)
                return parseInt(this.soins.acte_total + this.soins.consommable_total + this.soins.injectable_total)
            else
                return 0
        },

        total() {
            let sum = 0

            if (this.consultation) {
                if (
                    this.consultation_paye >= 0 || this.b_total_examen >= 0 || this.b_total_analyse >= 0 || 
                    (this.soins.acte_total >= 0 || this.soins.consommable_total >= 0 || this.soins.injectable_total >= 0)
                ) {
                    sum = (this.consultation_paye) + (this.b_total_analyse) + parseInt(this.b_total_examen) + 
                        parseInt(this.b_total_acte) + this.b_total_inj + this.b_total_conso + parseInt(this.b_total_ordonnance) +
                        this.b_total_admission

                    this.display_all_loading = false;
                }
            }
            
            return sum
        },

        total_paye_assureur() {
            let total = 0
            // total = this.total_assureur.protocoles 

            total = this.total_assureur.consultation + this.total_assureur.analyse + this.total_assureur.examen_para + 
                    this.total_assureur.protocoles + this.total_assureur.ordonnance

            return total;
        },

        total_paye_assure() {
            let total = 0
            // total = this.total_assure.protocoles

            total = this.total_assure.consultation + this.total_assure.analyse + this.total_assure.examen_para + 
                this.total_assure.protocoles + this.total_assure.ordonnance

            return total;
        },

        total_restant() {
            // return parseInt(this.consultation_reste) + parseInt(this.analyses_reste) + parseInt(this.prescriptions_reste) + this.p_soins_restant + this.total_reste_examen
            return parseInt(this.consultation_reste) + parseInt(this.analyses_reste) + this.p_soins_restant + 
                    this.total_reste_examen + this.prescriptions_reste
        },

        demande_examen_consultation() {
            return this.$store.getters["demande_examen_consultation"]
        },

        // total_examen() {
        //     this.demande_examen_consultation.forEach(element => {
        //         if (element.est_paye == 1) {
        //             this.total_prix_examen += parseInt(element.type_examen_prix)
        //         }
        //     });
        //     return this.total_prix_examen
        // }

    },
    mounted() {
        this.date_facture = convertDateToDdMmYyyy.convertDate(new Date());

        

        if (this.userCredentials.user.roles.length > 0) {
            this.user_id = this.userCredentials.user.id
            this.user_role = this.userCredentials.user.roles[0].nom;

            if (this.activeRole.nom == 'ROLE_CAISSIERE') {
                this.compte_id = 1 //  Caisse principale
            } else if (this.activeRole.nom == 'ROLE_CAISSIERE_INTERMITENT') {
                this.compte_id = 4 //  Caisse 1 (Infirmier)
            } else if (this.activeRole.nom == 'ROLE_COMPTABLE') {
                this.compte_id = 3 //  Comptabilité
            }
        }

        // >>>> Etat d'ouverture d'une caisse
        this.$store.dispatch('getStatutOuvertureCaisse', this.compte_id).then((response) => {
            if (response == 1) {
                this.$router.push({ path: '/clinicaa/comptabilite/caisse' })
            }
        });

        // recupérer la consultation
        this.$store.dispatch('getTypesForConsultation', this.passedConsult).then((response) => {
            let t = new Date()
            this.filename = 'Facture_'+response.patient.nom+'_'+response.patient.prenoms+'_'+t.getTime()

            this.display_all_loading = false;
            this.consult_back = response
            $('.p-content').fadeIn();
            

            // Verifie si le patient est assuré
            this.$store.dispatch('checkIfPatientEstAssure', response.patient_id)

            // Info Assurance
            this.$store.dispatch('getPatientInfoAssurance', { patient_id: response.patient_id })

            //recuperation de loperation afin de vérifier si  consultation a été soldé et recupérer les carnets
            if(response.operation_id > 0 && response.est_paye < 2) {
                this.$store.dispatch('getAnOperation', response.operation_id).then(
                    (op_data) => {
                        this.prix_consult = op_data
                        this.carnets = op_data.enfants;

                        let base_assurance = (this.consult_back.prix_prestation > 0)?parseInt(this.consult_back.prix_prestation):0
                        // let part_assure = (this.consult_back.prix_assure > 0)?parseInt(this.consult_back.prix_assure):0
                        
                        if (!op_data.comptabilise || op_data.comptabilise == 0) {
                            // this.consultation_reste = parseInt(op_data.montant)
                            this.consultation_reste = op_data.montant + parseInt(this.prix_carnet)
                        }

                        if (this.patient_est_assure == 1) {
                            if (parseInt(this.consult_back.prix) == 0) {
                                this.consultation_paye = parseInt(this.consult_back.tarif_consultation.prix) + parseInt(this.prix_carnet)
                            } else {
                                this.consultation_paye = parseInt(this.consult_back.prix) + parseInt(this.prix_carnet)
                            }

                            this.total_assureur.consultation = this.info_assurance['taux_consultation'] * base_assurance
                            this.total_assure.consultation = parseInt(op_data.montant) + parseInt(this.prix_carnet)
                        } else {
                            this.consultation_paye = parseInt(op_data.montant) + parseInt(this.prix_carnet)
                        }
                    }
                )
            }
            

        });

        //recuperer les prescriptions
        this.$store.dispatch('getPrescriptionsPharmacie', { consultation_id: this.passedConsult, bought: 2 }).then(() => {
            // enregistrer la liste des quantités
            this.prescription.forEach(data => {
                this.prix_ord[data.id] = 0
                let qte = 0

                qte = (parseInt(data.quantite_differe) == 0)?data.quantite_achat:data.quantite_differe

                if (this.patient_est_assure == 1) {     //  >>>>>> PATIENT  ASSURE
                    this.prix_ord[data.id] = parseInt(data.prix_assure)

                    if (parseInt(data.quantite_differe) == 0) {     // Paiement encaissé
                         
                        this.total_assure.ordonnance += parseInt(data.prix_assure) * qte
                    }
                    this.total_assureur.ordonnance += ( data.prix_prestation - parseInt(data.prix_assure) )

                    // Reste à payer
                    this.prescriptions_reste += parseInt(data.quantite_differe * data.prix_assure);
                } else {
                    this.prix_ord[data.id] = parseInt(data.prix)
                    this.prescriptions_reste += parseInt(data.quantite_differe * data.prix);
                }

                if (parseInt(data.quantite_differe) == 0 || data.prix_prestation == '0') {
                    // if (data.prix_prestation == 0) {
                    //     this.b_total_ordonnance += parseInt(data.prix) * qte
                    // }else {
                    //     this.b_total_ordonnance += parseInt(data.prix_prestation) * qte
                    // }
                    this.b_total_ordonnance += parseInt(data.prix) * qte
                }

                this.qte_medoc.push(data.quantite_achat - data.quantite_differe);
                
            })

        })

        //looping soins object 
        this.$store.dispatch('getSoinsEnCoursByConsultation', { 
            consultation_id: this.passedConsult, soins_state: 3 
        }).then((response) => {
            this.total_assureur.protocoles = 0
            this.total_assure.protocoles = 0
            this.p_soins_restant = 0
            
            // this.soins = response[0]
            let payes = response.payes[0];
            let differes = response.differes[0];
            // this.soins_differes = response.differes[0];

            let prix_actes = 0
            let prix_consommable = 0
            let prix_admissions = 0

            // >>>>>>>>>>   PROTOCOLES EST PAYE
            if (payes.acte_total > 0) {
                payes.admissions.forEach(p_hospi => {
                    prix_admissions += parseInt(p_hospi.total)
                    this.b_total_admission = prix_admissions
                });

                payes.actes.forEach(p_acte => {
                    prix_actes += parseInt(p_acte.total)
                    this.b_total_acte = prix_actes
                });

                payes.consommables.forEach(p_conso => {
                    prix_consommable += parseInt(p_conso.total)
                    this.b_total_conso = prix_consommable
                });

                payes.injectables.forEach(p_injectable => {
                    this.p_assure[p_injectable.id] = 0
                    this.p_tot_assure[p_injectable.id] = 0

                    this.prix_injectables += parseInt(p_injectable.total)
                    this.b_total_inj = this.prix_injectables
                    if (this.patient_est_assure == 0) {  
                        this.total_assureur.protocoles += 0
                        this.total_assure.protocoles += ( p_injectable.total )
                    } else {
                        /**
                         * Si le patient est assuré INAM l'on applique la base INAM
                         *   sinon l'on applique le % sur le prix clinique
                         */
                        if (p_injectable.est_exclu == 0) {
                           
                            if (this.info_assurance['raison_sociale'] == 'INAM') {
                                this.total_assureur.protocoles += ( p_injectable.total_prestation * this.info_assurance['taux_consultation'] )
                                this.total_assure.protocoles += p_injectable.total_prix_assure
                                // this.prix_inj[p_injectable.id] = p_injectable.prix_assure
                            } else {
                                this.total_assureur.protocoles += ( p_injectable.total * this.info_assurance['taux_consultation'] )
                                
                                this.p_assure[p_injectable.id] = Math.ceil((1 - this.info_assurance['taux_consultation']) * p_injectable.prix)
                                this.p_tot_assure[p_injectable.id] = Math.ceil((1 - this.info_assurance['taux_consultation']) * p_injectable.total)
                                this.total_assure.protocoles += this.p_tot_assure[p_injectable.id] //p_injectable.prix_assure
                            }
                        } else {
                            this.total_assureur.protocoles += 0
                            // this.prix_inj[p_injectable.id] = p_injectable.prix
                            this.total_assure.protocoles += ( p_injectable.total )
                        } 
                    }
                    
                });
                this.total_assure.protocoles = this.total_assure.protocoles + prix_actes + prix_consommable + prix_admissions
                // this.b_total_acte = this.total_assure.protocoles
            }

            

            if (payes && differes) {
                // ------ADMISSIONS
                differes.admissions.forEach(element => {
                    let hospi_identique = payes.admissions.find(el => el.id == element.id)
                    if (hospi_identique) {
                        let ind = payes.admissions.indexOf(hospi_identique);
                        payes.admissions[ind].qte_differe = element.qte;
                        payes.admissions[ind].total_differe = element.total;
                        payes.admissions[ind].libelle = element.admission
                    } else { // cet élément n'existe pas dans l'array paye
                        
                        payes.admissions.push({
                            id: element.id,
                            libelle: element.admission,
                            prix: element.prix,
                            qte: 0,
                            qte_differe: element.qte,
                            total: 0,
                            total_differe: element.total
                        })
                        
                    }
                    this.p_soins_restant += (element.total)?element.total:0
                });

                // ------actes
                differes.actes.forEach(element => {
                    let acte_identique = payes.actes.find(el => el.id == element.id)
                    if (acte_identique) {
                        
                        let ind = payes.actes.indexOf(acte_identique);
                        
                        payes.actes[ind].qte_differe = element.qte;
                        payes.actes[ind].total_differe = element.total;
                    } else { // cet élément n'existe pas dans l'array paye
                        payes.actes.push({
                            id: element.id,
                            libelle: element.libelle,
                            prix: element.prix,
                            qte: 0,
                            qte_differe: element.qte,
                            total: 0,
                            total_differe: element.total
                        })

                        // this.p_soins_restant += (element.total)?element.total:0
                    }
                    this.p_soins_restant += (element.total)?element.total:0
                });

                //------consommables
                differes.consommables.forEach(element => {
                    let identique = payes.consommables.find(el => el.id == element.id)
                    if (identique) {
                        let ind = payes.consommables.indexOf(identique);
                        payes.consommables[ind].qte_differe = element.qte;
                        payes.consommables[ind].total_differe = element.total;
                    } else { // cet élément n'existe pas dans l'array paye
                        payes.consommables.push({
                            id: element.id,
                            libelle: element.libelle,
                            prix: element.prix,
                            qte: 0,
                            qte_differe: element.qte,
                            total: 0,
                            total_differe: element.total
                        })
                    }
                    this.p_soins_restant += (element.total)?element.total:0
                });

                //------injectables
                differes.injectables.forEach(element => {
                    let identique = payes.injectables.find(el => el.id == element.id)
                    
                    
                    let pu_injectable = 0
                    if (this.patient_est_assure == 1) {
                        pu_injectable = element.prix - (element.prix * this.info_assurance['taux_consultation'])
                    } else {
                        pu_injectable = element.prix
                    }

                    this.prix_inj[element.id] = pu_injectable

                    if (identique) {
                        let ind = payes.injectables.indexOf(identique);
                        payes.injectables[ind].qte_differe = element.qte;
                        payes.injectables[ind].total_differe = element.total;
                    } else { // cet élément n'existe pas dans l'array paye
                        payes.injectables.push({
                            est_exclu: element.est_exclu,
                            id: element.id,
                            libelle: element.libelle,
                            prix: parseInt(element.prix),
                            prix_assure: element.prix_assure,
                            prix_prestation: element.prix_prestation,
                            total_prix_assure: element.total,   //element.total_prix_assure
                            total_prestation: element.total_prestation,
                            qte: 0,
                            qte_differe: element.qte,
                            total: 0,
                            total_differe: element.total   //element.total_prix_assure
                        })
                    }
                    this.p_soins_restant += element.total
                    
                });

                this.soins = payes

                this.soins.injectables.forEach(data => {
                    if (this.patient_est_assure == 0) {  
                        // this.total_assureur.protocoles += 0
                        // this.total_assure.protocoles += ( data.total )
                    } else {
                        
                        /**
                         * Si le patient est assuré INAM l'on applique la base INAM
                         *   sinon l'on applique le % sur le prix clinique
                         */
                        if (data.est_exclu == 0) {
                            if (this.info_assurance['raison_sociale'] == 'INAM') {
                                this.prix_inj[data.id] = data.prix_assure
                            } else {
                                this.prix_inj[data.id] = data.total_prix_assure
                            }
                        } else {
                            this.prix_inj[data.id] = data.prix
                        }
                    }
                })

                this.soins.actes.forEach(p_acte => {
                    if (differes.acte_total > 0) {
                        prix_actes += (p_acte.total_differe)?p_acte.total_differe:0
                    }
                    if (payes.acte_total > 0) {
                        prix_actes += (p_acte.total)?p_acte.total:0
                    }
                });

                this.soins.consommables.forEach(p_conso => {
                    if (differes.acte_total > 0) {
                        prix_consommable += (p_conso.total_differe)?p_conso.total_differe:0
                    }
                    if (payes.acte_total > 0) {
                        prix_consommable += (p_conso.total)?p_conso.total:0
                    }
                });
                // this.total_assure.protocoles = this.total_assure.protocoles + prix_actes + prix_consommable
            }
            this.$store.dispatch('getCatJourID', this.passedConsult);
        })

        //recuperer les analyses
        this.$store.dispatch('getAnalysesForConsult', { consultation_id: this.passedConsult, bought: 1 }).then((response) => {
            
            response.forEach(async (data) =>  {
                this.prix_anal[data.analyse.id] = 0

                if (this.patient_est_assure == 1) {     //  >>>>>> PATIENT  ASSURE
                    // let base_analyse = 0
                    if (data.est_differe == '0' && data.traite == '1') { 
                        this.total_assure.analyse += parseInt(data.prix_assure)
                    }
                    this.total_assureur.analyse += ( data.prix_prestation - parseInt(data.prix_assure) )
                }
                
                await this.setStatusPaidAnalyse(data.operation_id, data.analyse.id, parseInt(data.analyse.prix)) 
            })
        })

        /**
         * Demande d'examens paracliniques payés et différés
         */
        this.$store.dispatch('getConsultationExamen', { consultation_id: this.passedConsult, etat_paiement: 3 }).then(() => {
            this.demande_examen_consultation.forEach(async(elmt) => {
                this.prix_exm[elmt.examen_id] = 0

                if (this.patient_est_assure == 1) {     //  >>>>>> PATIENT  ASSURE
                    // let base_analyse = 0
                    if (elmt.est_paye == '1') { 
                        this.total_assure.examen_para += parseInt(elmt.part_assure)
                    }
                    this.total_assureur.examen_para += ( parseInt(elmt.base_assurance) - parseInt(elmt.part_assure) )
                    
                }
                

                await this.getInfoExamenPara(elmt.operation_id, elmt.examen_id, parseInt(elmt.base_assurance))
            });

            

        })
    },
    methods: {
        // refreshFacture() {

        // },
        
        date_function: function() {
            let date = new Date()
                // let expiration_d = new Date()
                // expiration_d.setDate(date.getDate() + 15)

            let today_month = date.getMonth() + 1
                // let expir_month = expiration_d.getMonth() + 1

            this.today_date = date.getDate() + '/' + today_month + '/' + date.getFullYear()
                // this.expiration_date = expiration_d.getDate() + '/' + expir_month + '/' + expiration_d.getFullYear()

            this.ref_bon = date.getHours() + '' + date.getMinutes() + '' + date.getSeconds() + '/' + today_month + '/' + date.getDate()
        },

        formatNumbers(num) {
            return new Number(num).toLocaleString("fr-FR");
        },

        getInfoExamenPara(id_operation, examen_id, prix_prestation) {
            this.$store.dispatch('getAnOperation', id_operation).then(
                (response) => {
                    // this.prix_anal_loading = false
                    this.prix_exm[examen_id] = response.montant

                    if (response.comptabilise == true || parseInt(response.comptabilise) == 1) {
                        this.total_prix_examen += parseInt(response.montant)

                        if (prix_prestation > 0) {
                            this.b_total_examen += parseInt(prix_prestation)
                        }else {
                            this.b_total_examen += parseInt(response.montant)
                        }
                    } else {
                        this.total_reste_examen += parseInt(response.montant)
                    }
                }
            )
        },

        setStatusPaidAnalyse(id_operation, analyse_id, prix_prestation) {
            this.$store.dispatch('getAnOperation', id_operation).then(
                
                (response) => {
                    this.prix_anal_loading = false
                    this.prix_anal[analyse_id] = response.montant

                    if (response.comptabilise == true || parseInt(response.comptabilise) == 1) {
                        this.analyses_paye += parseInt(response.montant)

                        if (prix_prestation > 0) {
                            this.b_total_analyse += parseInt(prix_prestation)
                        }else {
                            this.b_total_analyse += parseInt(response.montant)
                        }
                    } else {
                        this.analyses_reste += parseInt(response.montant)
                    }
                }
            )
        },

        getAnalysesEtats(index){
            
            if(this.analyse_paid_status[index] ==="1")
            {
                return true
            }
            return false;
        },

        doAfterSuccess(comptabilise) {
            $('.modal').modal('hide')
            if (comptabilise == false) {
                this.doSuccessMsg('L\'enregistrement a été fait. L\'encaissement a été différé');
            } else {
                this.doSuccessMsg('Enregistrement et encaissement effectués');
            }
            this.save_loading = false;
            this.is_printable = true;
            this.is_savable = false;
            this.$router.push({ path: '/dashboard' })
            confirm.checked = false
        },

        doAfterErrorVente(error) {
            this.save_loading = false;

            $('.modal').modal('hide')

            var message = ""
            error.forEach((element, index) => {
                if (index == error.length - 1) {
                    message = message + element.libelle

                } else {
                    message = message + element.libelle + " ,"
                }
            });


            this.$toasted.show('Certains articles sont indisponible :' + message, {
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                position: 'top-center',
                duration: 5000,
                theme: 'toasted-primary',
                type: 'error'
            })

        },


        doSuccessMsg: function(msg) {
            this.$toasted.show(msg, {
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                position: 'top-center',
                duration: 5000,
                theme: 'toasted-primary',
                type: 'success'
            })
        },
        doErrorMsg: function() {
            this.$toasted.show('Veuillez choisir tous les éléments nécessaires pour l\'enregistrement', {
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                position: 'top-center',
                duration: 5000,
                theme: 'toasted-primary',
                type: 'error'
            })
        },
        openMenu(state, selector, show_in, show_out) {
            this.vm_state = openMenu.dropMenu(state, selector, show_in, show_out)
        },

        /**
         * Close Menu Dropdown
         */
        closeMenu(selector, show_in, show_out) {
            this.vm_state = closeMenu.wrapMenu(selector, show_in, show_out)
            this.operation_selected = selector
        },
        closeModal(selector) {
            closeModal.closeModal(selector);
        },


        printFacture() {
            this.$refs.facture_html2Pdf.generatePdf()
        },

        async beforeDownload({ html2pdf, options, pdfContent }) {
            await html2pdf().set(options).from(pdfContent).toPdf().get('pdf').then((pdf) => {
                // const totalPages = pdf.internal.getNumberOfPages()

                let foot_content = 'Généré(e) via l\'application Clinicaa';

                let la_caisse = 'La caisse';
                let lome_le = cca_config.VILLE+', le ' + this.date_facture;

                // LOME LE
                pdf.setTextColor(150)
                pdf.setFontSize(10)
                pdf.text(lome_le, (0.5), (pdf.internal.pageSize.getHeight() - 1))

                // LA CAISSE
                pdf.setTextColor(150)
                pdf.setFontSize(10)
                pdf.text(la_caisse, (7), (pdf.internal.pageSize.getHeight() - 1))

                // FOOTER
                pdf.setTextColor(150)
                pdf.setFontSize(6)
                pdf.text(foot_content, (3.333858), (pdf.internal.pageSize.getHeight() - 0.3))
            }).save()
        },

        onProgress() {
            // TODO
        },

        hasStartedGeneration() {

        },

        hasGenerated() {
            // TODO
        }
    }
}